import { render, staticRenderFns } from "./DonorboxConfirmation.vue?vue&type=template&id=8b822b94&scoped=true&"
import script from "./DonorboxConfirmation.vue?vue&type=script&lang=js&"
export * from "./DonorboxConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DonorboxConfirmation.vue?vue&type=style&index=0&id=8b822b94&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b822b94",
  null
  
)

export default component.exports